export const DEFAULT_CATEGORIES = [
  { id: 1, nome: "Hortifruti", keywords: ["banana", "laranja", "mamao", "uva", "alho", "tomate", "cebola", "batata", "limao", "maca", "morango", "abacaxi", "melancia", "melao", "kiwi", "manga", "pera", "pessego", "goiaba", "maracuja", "cenoura", "chuchu", "abobrinha", "berinjela", "alface", "couve", "espinafre", "salsinha", "cebolinha", "repolho", "pimentao", "brocolis"], cor: "#10b981", icone: "🍅" },
  { id: 2, nome: "Açougue & Peixaria", keywords: ["carne", "frango", "peixe", "atum", "linguica", "salsicha", "hamburguer", "bife", "costela", "file", "alcatra", "picanha", "maminha", "acem", "patinho", "moida", "cupim", "coxa", "sobrecoxa", "tilapia", "camarao", "kibe", "nugget", "empanado"], cor: "#ef4444", icone: "🥩" },
  { id: 3, nome: "Frios & Laticínios", keywords: ["leite", "iogurte", "iog", "queijo", "manteiga", "creme", "requeijao", "danoninho", "danone", "activia", "nata", "margarina", "mussarela", "mozarela", "prato", "provolone", "gorgonzola", "ricota", "cottage", "bebida lactea", "presunto", "apresuntado", "mortadela", "salame", "bacon", "peito peru", "blanquet"], cor: "#3b82f6", icone: "🧀" },
  { id: 4, nome: "Padaria & Sobremesas", keywords: ["pao", "pães", "bolo", "torta", "croissant", "bisnaguinha", "rosca", "brioche", "torrada", "panetone", "chocotone", "cuca", "sonho", "doce", "maria mole", "pudim", "gelatina"], cor: "#f59e0b", icone: "🍞" },
  { id: 5, nome: "Mercearia", keywords: ["ketchup", "maionese", "leite condensado", "oleo", "azeite", "arroz", "feijao", "macarrao", "massa", "spaghetti", "espaguete", "penne", "parafuso", "miojo", "molho", "extrato", "farinha", "acucar", "sal", "tempero", "caldo", "sazon", "knorr", "azeitona", "milho", "ervilha", "palmito", "sardinha", "champignon", "cafe", "nescafe", "pilao", "caboclo", "3 coracoes", "achocolatado", "toddy", "nescau", "aveia", "granola", "cereal", "geleia", "mel", "adoçante", "cappuccino", "biscoito", "bisc", "bolacha", "salgadinho", "ruffles", "cheetos", "doritos", "fandangos", "wafer", "chocolate", "bala", "chiclete", "bombom", "pipoca", "amendoim", "castanha"], cor: "#6366f1", icone: "🥫" },
  { id: 6, nome: "Bebidas", keywords: ["cerveja", "chopp", "refrigerante", "refri", "suco", "agua", "vinho", "espumante", "energetico", "coca", "guarana", "pepsi", "sprite", "fanta", "cha", "matte", "monster", "red bull", "gin", "vodka", "whisky"], cor: "#f97316", icone: "🥤" },
  { id: 7, nome: "Congelados", keywords: ["congelado", "pizza", "lasanha", "sorvete", "picole", "batata frita congelada", "pao queijo"], cor: "#60a5fa", icone: "❄️" },
  { id: 8, nome: "Limpeza", keywords: ["detergente", "desinfetante", "esponja", "sabao", "alvejante", "amaciante", "limpador", "agua sanitaria", "lixo", "guardanapo", "papel toalha", "papel aluminio", "filme pvc"], cor: "#06b6d4", icone: "🧼" },
  { id: 9, nome: "Higiene Pessoal", keywords: ["sabonete", "shampoo", "condicionador", "creme dental", "pasta dente", "colgate", "dove", "rexona", "desodorante", "papel higienico", "escova", "fralda", "absorvente", "lamina", "gillette", "enxaguante", "fio dental"], cor: "#ec4899", icone: "🧴" },
  { id: 10, nome: "Pet Shop", keywords: ["racao", "sache", "petisco", "areia gato"], cor: "#a855f7", icone: "🐶" },
  { id: 11, nome: "Bazar & Utilidades", keywords: ["ferramenta", "chave", "prego", "fita", "cola", "caderno", "caneta", "copo", "prato", "talher", "panela", "vasilha", "tupperware", "luz", "lampada", "pilha"], cor: "#8b5cf6", icone: "🛠️" },
  { id: 12, nome: "Eletro & Eletrônicos", keywords: ["tv", "televisao", "radio", "som", "liquidificador", "batedeira", "fritadeira", "air fryer", "microondas", "geladeira", "fogao", "maquina lavar", "ventilador", "celular", "smartphone", "fone", "carregador"], cor: "#64748b", icone: "📺" },
  { id: 13, nome: "Vestuário", keywords: ["camisa", "camiseta", "calca", "bermuda", "cueca", "calcinha", "sutia", "meia", "tenis", "sapato", "chinelo", "havaianas", "vestido", "saia", "jaqueta", "casaco"], cor: "#14b8a6", icone: "👕" },
  { id: 14, nome: "Outros", keywords: [], cor: "#94a3b8", icone: "❓" }
];

export function getCategoryIcon(nome) {
  if (!nome) return '❓';
  const found = DEFAULT_CATEGORIES.find(c => c.nome.toLowerCase() === nome.toLowerCase());
  if (found) return found.icone;
  
  const clean = nome.toLowerCase();
  if (clean.includes('padaria')) return '🍞';
  if (clean.includes('carne') || clean.includes('açougue')) return '🥩';
  if (clean.includes('hortifruti') || clean.includes('fruta')) return '🍅';
  if (clean.includes('frios') || clean.includes('latic')) return '🧀';
  if (clean.includes('doce') || clean.includes('bisc') || clean.includes('sobremesa')) return '🍫';
  if (clean.includes('higiene')) return '🧴';
  if (clean.includes('bebida')) return '🥤';
  if (clean.includes('mercearia')) return '🥫';
  if (clean.includes('limpeza')) return '🧼';
  if (clean.includes('pet')) return '🐶';
  if (clean.includes('congelado')) return '❄️';
  if (clean.includes('bazar') || clean.includes('utilidade')) return '🛠️';
  if (clean.includes('eletro')) return '📺';
  if (clean.includes('vestu')) return '👕';
  
  return '📦'; // Ícone padrão para categorias customizadas
}

export function normalizeText(text) {
  if (!text) return '';
  return text
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}

export function categorizeItem(descricao, categories = DEFAULT_CATEGORIES) {
  const normDesc = normalizeText(descricao);
  const words = normDesc.split(/[\s,.-]+/);

  for (const cat of categories) {
    if (!cat.keywords || cat.keywords.length === 0) continue;
    for (const kw of cat.keywords) {
      const normKw = normalizeText(kw);
      if (!normKw) continue;
      if (normKw.length <= 3) {
        if (words.includes(normKw)) {
          return cat;
        }
      } else {
        if (normDesc.includes(normKw)) {
          return cat;
        }
      }
    }
  }

  return categories.find(c => c.nome === 'Outros') || DEFAULT_CATEGORIES[DEFAULT_CATEGORIES.length - 1];
}

export function recategorizeNota(nota, categories = DEFAULT_CATEGORIES) {
  if (!nota || !nota.itens) return nota;

  const updatedItens = nota.itens.map(item => {
    const cat = categorizeItem(item.descricao, categories);
    return {
      ...item,
      categoriaId: cat.id,
      categoriaNome: cat.nome
    };
  });

  return {
    ...nota,
    itens: updatedItens
  };
}

export function isDiscretionaryItem(descricao, categoriaNome = '') {
  if (!descricao) return false;
  const normDesc = normalizeText(descricao);
  const normCat = normalizeText(categoriaNome);

  if (normCat.includes('doce') || normCat.includes('bisc')) return true;

  const discretionaryKeywords = [
    'chocolate', 'salgadinho', 'ruffles', 'cheetos', 'doritos', 'fandangos',
    'wafer', 'waffer', 'bala', 'chiclete', 'bombom', 'pipoca', 'gelatina',
    'pudim', 'sorvete', 'picole', 'picolé', 'refrigerante', 'refri', 'coca',
    'guarana', 'guaraná', 'pepsi', 'sprite', 'fanta', 'cerveja', 'chopp',
    'vinho', 'espumante', 'energetico', 'energético', 'monster', 'red bull',
    'gin', 'vodka', 'whisky', 'snack', 'guloseima'
  ];

  return discretionaryKeywords.some(kw => normDesc.includes(kw));
}


import { getProductOverride } from './db.js';

export async function categorizeItemAsync(item, categories = DEFAULT_CATEGORIES) {
  const key = item.ean || item.codigo || item.descricao;
  const override = await getProductOverride(key);
  if (override) {
    return {
      id: override.categoryId,
      nome: override.categoryName
    };
  }
  
  // Fallback to old behavior
  return categorizeItem(item.descricao, categories);
}

export async function recategorizeNotaAsync(nota, categories = DEFAULT_CATEGORIES) {
  if (!nota || !nota.itens) return nota;

  const updatedItens = await Promise.all(nota.itens.map(async item => {
    const cat = await categorizeItemAsync(item, categories);
    return {
      ...item,
      categoriaId: cat.id,
      categoriaNome: cat.nome
    };
  }));

  return {
    ...nota,
    itens: updatedItens
  };
}
